type OpenAIInput = {
  prompt?: string

  imageUrl?: string
  roomImage?: any

  room_type?: string
  roomType?: string

  style?: string
  identity?: string

  mood_text?: string

  productSku?: string
  productImage?: string
}


type OpenAIResponse = {
  image_base64?: string
  text?: string
  images?: string[]
  image_urls?: string[]
}

export async function runOpenAI(data: OpenAIInput): Promise<OpenAIResponse> {
const res = await fetch("/api/ai/generate-image", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  })

  if (!res.ok) {
    throw new Error("OpenAI request failed")
  }

  return res.json()
}